// extracted by mini-css-extract-plugin
module.exports = {"header":"ProductsSlider_header__sV_6k","sliderContainer":"ProductsSlider_sliderContainer__6TEHg"};